import { Theme, makeStyles } from "@material-ui/core"

import { MAX_SHOWN_UNREAD_COUNT } from "../hooks/use-entity-chat-unread-count"

type Props = {
  count: number
}

const UnreadCountBadge = ({ count }: Props) => {
  const classes = useStyles()

  if (count <= 0) return null

  return <span className={classes.badge}>{count > MAX_SHOWN_UNREAD_COUNT ? `${MAX_SHOWN_UNREAD_COUNT}+` : count}</span>
}

const useStyles = makeStyles((theme: Theme) => ({
  badge: {
    flexShrink: 0,
    minWidth: 20,
    height: 20,
    padding: theme.spacing(0, 0.75),
    borderRadius: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
  },
}))

export default UnreadCountBadge
